export enum EditSectionEnum {
  DATAS = 'DATAS',
  DISPLAY = 'DISPLAY',
  OPTIONS = 'OPTIONS',
}
